'use client';
import Chatbot from '@/components/chatbot';
import { CommerceModal } from '@/components/modal';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { commerceJWT } from '@repo/ecommerce-api';
import { OfflineBanner, ReduxToast, theme } from '@repo/ui';
import { getClientCookie, parseJwt, SendNavigatorData } from '@repo/utils';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { hideToast } from './navigationSlice';
import { makeStore, RootState } from './store';
import { pushUserdata, resetUserdata } from './userdataSlice';

const LoadUserData = () => {
  const dispatch = useDispatch();
  const token = getClientCookie('token-commerce');
  const pathname = usePathname();

  useEffect(() => {
    // Parsed inside the effect: a fresh object per render would re-run it on every render
    const decodedToken = parseJwt(token || '') as commerceJWT;
    if (decodedToken && pathname !== '/login') {
      dispatch(
        pushUserdata({
          isAuth: true,
          username: decodedToken.sub,
          role: decodedToken.role,
          ecommerce: decodedToken?.ecommerce,
          comercionombre: decodedToken?.comercionombre,
          comerciocodigo: decodedToken?.comerciocodigo,
        }),
      );
    } else {
      dispatch(resetUserdata());
    }
  }, [dispatch, token, pathname]);
  return <></>;
};

export function Providers({ children }: { children: React.ReactNode }) {
  const [store] = useState(makeStore);
  useEffect(() => {
    SendNavigatorData({
      app: 'commerce',
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <OfflineBanner />
      <Provider store={store}>
        <LoadUserData />
        <ReduxToast selectToast={(state: RootState) => state.navigationdata.toastData} hideToast={hideToast} />
        <CommerceModal />
        {children}
        <Chatbot />
      </Provider>
    </ThemeProvider>
  );
}
